import React from 'react';
import './QuantityInput.css';

const QuantityInput = ({ quantity, onChange, maxStock }) => {
    const handleDecrement = () => {
        const newQuantity = Math.max(1, quantity - 1);
        onChange(newQuantity); // Langsung panggil fungsi onChange
    };

    const handleIncrement = () => {
        const newQuantity = Math.min(maxStock, quantity + 1);
        onChange(newQuantity); // Langsung panggil fungsi onChange
    };

    const handleInputChange = (e) => {
        const value = parseInt(e.target.value);
        if (isNaN(value) || value < 1) {
            onChange(1);
        } else if (value > maxStock) {
            onChange(maxStock);
        } else {
            onChange(value);
        }
    };

    return (
        <div className="quantity-input-wrapper">
            <button type="button" onClick={handleDecrement} disabled={quantity <= 1}>-</button>
            <input 
                type="number" 
                value={quantity} 
                onChange={handleInputChange}
                min="1"
                max={maxStock}
            />
            <button type="button" onClick={handleIncrement} disabled={quantity >= maxStock}>+</button>
        </div>
    );
};

export default QuantityInput;